// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"b5068fd6","60":"a411098e","382":"b81ec5dc","512":"bd4e086c","772":"f381bbe0","802":"72b797e1","821":"cebda051"}[chunkId] + ".chunk.js";
};